/**
 * The UPI string for a bill's QR (docs/finance/phase-3-plan.md §4.2). The same string as finance.upi_uri in the database and the
 * template's upiLink(): only pa, pn, am, cu, tn; '@' stays literal, because some UPI apps show %40 as it is written.
 */
import { upiAmount } from './money';
import type { Paise } from '../units/quantities';

const enc = (v: string): string => encodeURIComponent(v).replace(/%40/g, '@');

/** The link for a QR, with the amount from integer paise. A negative amount is refused (upiAmount). */
export function upiUri(a: { vpa: string; payee: string; amount: Paise; note: string }): string {
  return `upi://pay?pa=${enc(a.vpa)}&pn=${enc(a.payee)}&am=${upiAmount(a.amount)}&cu=INR&tn=${enc(a.note)}`;
}

/** Whether a string looks like a UPI ID: name@handle. */
export function isVpa(s: string): boolean {
  return /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z0-9.-]{2,64}$/.test(s);
}
